export default "__VITE_ASSET__83d69662__"